module.exports = __webpack_public_path__ + "static/preview-2-887941143a4b568d1a8a5ad8ae7e5250.jpg";